var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.statusCode === "active"
    ? _c("b-badge", { attrs: { variant: "success" } }, [
        _vm._v(_vm._s(_vm.statusName)),
      ])
    : _vm.statusCode === "pending"
    ? _c("b-badge", { attrs: { variant: "warning" } }, [
        _vm._v(_vm._s(_vm.statusName)),
      ])
    : _vm.statusCode === "suspended"
    ? _c("b-badge", { attrs: { variant: "danger" } }, [
        _vm._v(_vm._s(_vm.statusName)),
      ])
    : _c("b-badge", { attrs: { variant: "secondary" } }, [
        _vm._v(_vm._s(_vm.statusName)),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }